import { createSlice } from '@reduxjs/toolkit'

export const serviceSlice = createSlice({
  name: 'service',
  initialState: [],
  reducers: {
    getAllServicesAction:(state,action)=>{
    //console.log("from get all user action ",action.payload)
      return state=action.payload
    },
    addServiceAction: (state, action) => {
      //console.log("action payload from add user",action.payload)
      state.push(action.payload)
    },
    editServiceAction:(state,action)=>{
      let index = state.findIndex((user) => user.id === action.payload.id);
      //console.log("from edit action index ele ",index);
      //console.log("from edit action state[index] ",state[index],"paylod",action.payload);
       state[index] = action.payload;
    }
  }
})

// Action creators are generated for each case reducer function
export const { addServiceAction ,getAllServicesAction,editServiceAction} = serviceSlice.actions

export default serviceSlice.reducer